import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './EscrowOverviewScreen.css';
import api from '../../api';
import backArrowIcon from '../../assets/backarrow-icon.png';
import deleteIcon from '../../assets/delete-outline-icon.png'; // ✅ Custom delete icon
import { isOrderHidden, hideOrder } from '../../utils/orderHider';
import DeleteOrderDrawer from '../../components/popups/DeleteOrderDrawer';

function EscrowOverviewScreen({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [orders, setOrders] = useState([]);
  const [statusFilter, setStatusFilter] = useState(location.state?.fromFilter || 'all');
  const [deleteTarget, setDeleteTarget] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const buyerRes = await api.get(`/escrow/buyer/${user.username}`);
        const sellerRes = await api.get(`/escrow/seller/${user.username}`);
        setOrders([...buyerRes.data, ...sellerRes.data]);
      } catch (err) {
        console.error('❌ Failed to fetch orders:', err);
      }
    };

    fetchOrders();
  }, [user.username]);

  return (
    <div className="escrow-overview-container">
      <div className="overview-header">
        <img
          src={backArrowIcon}
          alt="Back"
          className="overview-back-icon"
          onClick={() => navigate('/marketplace', { replace: true })}
        />
        <h2>My Orders</h2>
      </div>

      <div className="overview-filter-bar">
        {['all', 'pending', 'completed', 'cancelled'].map((status) => (
          <button
            key={status}
            className={`filter-btn ${statusFilter === status ? 'active' : ''}`}
            onClick={() => setStatusFilter(status)}
          >
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </button>
        ))}
      </div>

      <div className="overview-scroll">
        {orders.length === 0 ? (
          <p className="no-orders-msg">You have no orders yet.</p>
        ) : (
          <div className="order-preview-list">
            {orders
              .filter(
                (order) =>
                  (statusFilter === 'all' || order.status === statusFilter) &&
                  !isOrderHidden(order._id, user.username)
              )
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((order) => {
                const product = order.productId;
                if (!product) return null;

                return (
                  <div
                    key={order._id}
                    className={`order-preview-card status-${order.status}`}
                    onClick={() =>
                      navigate(`/order/${order._id}`, {
                        state: { fromFilter: statusFilter },
                      })
                    }
                  >
                    <div className="order-status-bar" />

                    {/* ✅ Real delete icon */}

{['completed', 'cancelled'].includes(order.status) && (
  <img
    src={deleteIcon}
    alt="Delete"
    className="order-delete-icon"
    onClick={(e) => {
      e.stopPropagation(); // prevent navigation
      setDeleteTarget(order._id); // 🔁 Open drawer confirmation
    }}
  />
)}



                    <img
                      src={product.media?.[0]}
                      alt="product"
                      className="order-preview-img"
                    />
                    <div className="order-preview-info">
                      <p className="order-name">{product.name}</p>
                      <p className="order-price">{order.amount ?? 'N/A'} Pi</p>
                      <span className={`order-status ${order.status}`}>
                        {order.status}
                        {order.status === 'pending' && order.disputePaused && (
                          <span className="paused-label">⏸️ Paused</span>
                        )}
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </div>
<DeleteOrderDrawer
  visible={!!deleteTarget}
  onClose={() => setDeleteTarget(null)}
  onConfirm={() => {
    hideOrder(deleteTarget, user.username);
    setOrders((prev) => [...prev]); // force UI re-render
    setDeleteTarget(null);
  }}
/>


    </div>
  );
}

export default EscrowOverviewScreen;
